<template>
  <div class="main">
    <ball></ball>
    <!-- <div class="head">
      <div class="title">费用查询</div>
      <div class="ybpay">
        <div>是否使用医保个账支付</div>
        <div><van-switch v-model="checked" size="20px" active-color="#5b8df6" inactive-color="#ffffff" /></div>
      </div>
    </div> -->
    <div class="nav">
      <Nav :title="'处方明细'" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div>
      <div class="list">
        <div class="listrow">
          <div>就诊人</div>
          <div class="textcolor">{{ name }}</div>
        </div>
        <div class="listrow">
          <div>门诊流水号</div>
          <div class="textcolor">{{ registerId }}</div>
        </div>
        <div class="listrow">
          <div>总金额</div>
          <div class="red">￥{{ totPrice_data | FinalPrice }}</div>
        </div>
        <div class="listrow">
          <div>科室</div>
          <div class="textcolor">{{ treatDept }}</div>
        </div>
        <div class="listrow">
          <div>挂号日期</div>
          <div class="textcolor">{{ regDate }}</div>
        </div>
      </div>
      <div class="content_title">费用明细</div>
      <div class="detail">
        <div class="listrow">
          <div class="itemName project_c">项目名</div>
          <div class="count">数量</div>
          <div class="textcolor red price">价格</div>
        </div>

        <div
          class="listrow"
          v-for="(item, index) in Pay_prder_info.outFeeInfos"
          :key="index"
          @click="showitemname(item)"
        >
          <div class="itemName">{{ item.itemName }}</div>
          <div class="count">{{ item.amount }}{{ item.qtyUnit }}</div>
          <div class="price">￥{{ item.totCost | FinalPrice }}</div>
        </div>
      </div>
      <div class="list">
        <div class="last_list">
          <div class="itemName project_c">共计</div>
          <div class="textcolor red price">￥{{ totPrice | FinalPrice }}</div>
        </div>
      </div>
      <van-popup v-model="show" position="top" round
        ><div class="show_tite">项目名称</div>
        <div class="show_name">{{ show_name }}</div>
      </van-popup>
      <div class="last_item"></div>
      <div class="pay_list_foot">
        <div class="pay_text">
          <span class="money">￥{{ totPrice_data | FinalPrice }}</span>
        </div>
        <div class="pay_button" @click="goPay">支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      timer: null,
      cacheKey: null,
      //支付订单状态判断
      //总金额
      totPrice_data: null,
      //遮罩层name
      show_name: "",
      show: false,
      //就诊人卡号
      clientId: "",
      checked: false,
      registerId: "",
      recipeIdarr: [],
      totPrice: "",
      Pay_prder_info: [],
      pay_headr_info: [],
      //科室
      treatDept: "",
      //流水号
      registerId: "",
      //名字
      name: "",
      //总金额
      totPrice: 0,
      //挂号日期
      regDate: "",
      appId: "",
      timeStamp: "",
      nonceStr: "",
      pacKage: "",
      signType: "",
      paySign: "",
      //支付
      out_trade_no: "",
      order_record: {},
      payWay: "",
    };
  },
  mounted() {
    this.getpaydata();
  },
  filters: {
    FinalPrice(price) {
      return Number(price).toFixed(2);
      // console.log(price);
    },
  },
  methods: {
    //处理数组转字符串
    //数组转字符串[1,2,3]=>"1,2"
    acTiveArrStringFun(obj) {
      let string = obj.replace(/"/g, "").replace(/]/g, "").replace(/\[/g, "");
      return string;
    },

    //微信支付方法
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.appId, //公众号名称，由商户传入
          timeStamp: this.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.nonceStr, //随机串
          package: this.pacKage,
          signType: this.signType, //微信签名方式：
          paySign: this.paySign, //微信签名
        },
        (res) => {
          // this.$showLoad("请耐心等待，请勿返回");
          // if (res.err_msg == "get_brand_wcpay_request:ok") {
          //   // 使用以上方式判断前端返回,微信团队郑重提示：
          //   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          //   try {
          //     let url = "/pay/payconfirm";
          //     let R_data = {
          //       out_trade_no: this.out_trade_no,
          //       recipes: this.cacheKey,
          //     };
          //     this.$axios_request.request_data(
          //       "nodeserver",
          //       url,
          //       "POST",
          //       R_data,
          //       (data) => {
          //         this.$hideLoad()
          // if (data.status == 200) {
          this.$showLoad("支付确认中...");
          this.timer = setTimeout(() => {
            this.$hideLoad();
            this.$router.push({
              path: "/gaugelist",
              query: {
                clinicId: this.registerId,
              },
            });
          }, 4000);
        }
        //         else{
        //           this.$toast.fail("已退款，数据提交异常");
        //         }
        //       }
        //     );
        //   } catch (error) {
        //     console.log(error);
        //     this.$hideLoad();
        //   }
        // }
        // }
      );
    },
    showitemname(item) {
      this.show_name = item.itemName;
      this.show = true;
    },
    async goPay() {
      if (this.totPrice_data == 0) {
        try {
          this.$showLoad();
          // this.isLoad = true
          let url = "/outpatient/fee_record";
          let R_data = {
            medCardNo: this.clientId,
            clinicId: this.registerId,
            recipes: this.cacheKey,
          };
          await this.$axios_request.axios_request_body(
            "nodeserver",
            url,
            "POST",
            R_data,
            (data) => {
              this.$hideLoad();
              if (data.data.data.data.result == true) {
                this.$showLoad("支付确认中...");
                this.timer = setTimeout(() => {
                  this.$hideLoad();
                  this.$router.push({
                    path: "/ODpay_history_C",
                    query: {
                      name: this.name,
                      clientId: this.clientId,
                    },
                  });
                }, 2000);
              }else{
                this.$toast.fail('网络出错请稍后重试')
              }
            }
          );
        } catch (error) {
          console.log(error);
          this.$hideLoad();
        }
      } else {
        try {
          this.$showLoad();
          let data = {
            order_record: JSON.stringify(this.order_record),
            recipes: this.cacheKey,
          };
          let url = "/outpatientfee/order_record";
          await this.$axios_request.request_data(
            "nodeserver",
            url,
            "POST",
            data,
            (data) => {
              this.rowsAffected = data.data.rowsAffected;
              if (this.rowsAffected === 1) {
                this.$hideLoad();
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener(
                      "WeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      ),
                      false
                    );
                  } else if (document.attachEvent) {
                    document.attachEvent(
                      "WeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      )
                    );
                    document.attachEvent(
                      "onWeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      )
                    );
                  }
                } else {
                  this.$hideLoad();
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  );
                }
              } else {
                this.$toast.fail("支付出错请联系管理员");
              }
            }
          );
        } catch (error) {
          console.log(error);
          this.$hideLoad();
        }
      }
    },
    //获取参数 以及列表
    async getpaydata() {
      if (this.$route.query) {
        this.registerId = this.$route.query.registerId;
        this.recipeId = this.$route.query.recipeId;
        this.clientId = this.$route.query.clientId;
        this.payWay = this.$route.query.payWay;
        // console.log(this.clientId)
      }
      // console.log(this.payWay);
      try {
        this.$showLoad();
        // this.key  流水号
        // console.log("提交数据",JSON.stringify(data));

        this.isLoad = true;
        let url = "/outpatientfee/prepay";

        let goR_data = {
          registerId: this.registerId,
          recipeId: this.recipeId,
          clientId: this.clientId,
          payWay: this.payWay,
          mode: "outpatient", //处方缴费
          body: "门诊缴费 ",
          detail: "门诊缴费",
        };
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          goR_data,
          (data) => {
            if (data.status == 400) {
              this.$hideLoad();
              this.$toast.fail("处方号缴费出错，请联系管理员或到窗口缴费");
              // setTimeout(this.$router.go(-1),5000)
              return;
            } else if (data.statuscode == "1") {
              this.$hideLoad();
              this.Pay_prder_info = data.data.data.data;

              this.pay_headr_info = this.Pay_prder_info.outFeeInfos[0];
              this.treatDept = this.pay_headr_info.treatDept;
              this.name = this.pay_headr_info.clientName;
              this.registerId = this.pay_headr_info.registerId;
              this.regDate = this.pay_headr_info.regDate;
              this.medCardNo = this.pay_headr_info.medCardNo;
              this.totPrice_data = 0;
              this.cacheKey = this.Pay_prder_info.cacheKey;
              console.log(this.cacheKey);
              return;
            }
            this.Pay_prder_info = data.data.result_prepay.data;
            this.cacheKey = this.Pay_prder_info.cacheKey;
            this.out_trade_no = data.data.out_trade_no;
            this.order_record = data.data.order_record;
            //页面数据赋值
            if (this.Pay_prder_info.outFeeInfos[0]) {
              this.pay_headr_info = this.Pay_prder_info.outFeeInfos[0];
              this.treatDept = this.pay_headr_info.treatDept;
              this.name = this.pay_headr_info.clientName;
              this.registerId = this.pay_headr_info.registerId;
              this.regDate = this.pay_headr_info.regDate;
              this.medCardNo = this.pay_headr_info.medCardNo;
              //  console.log(this.treatDept)
              //  console.log(this.p)
            }
            let wechatpayInfo = data.data.result_uninorder;
            //微信支付需要参数赋值
            if (wechatpayInfo) {
              this.appId = wechatpayInfo.appId;
              this.timeStamp = wechatpayInfo.timeStamp;
              this.nonceStr = wechatpayInfo.nonceStr;
              this.pacKage = wechatpayInfo.package;
              this.signType = wechatpayInfo.signType;
              this.paySign = wechatpayInfo.paySign;
            }
            // console.log(this.Pay_prder_info.outFeeInfos);
            for (let item in this.Pay_prder_info.outFeeInfos) {
              this.totPrice += Number(
                this.Pay_prder_info.outFeeInfos[item].totCost
              );
              // console.log(this.totPrice)
            }
            this.totPrice_data = this.Pay_prder_info.totFee;
            // console.log(data);
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //获取预结算数据
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: #e74c3c;
}
.textcolor {
  color: #5b8df6;
}
.main {
  margin: 0;
  padding: 0;
  .top {
    height: 50px;
  }
  .head {
    color: #666666;
    margin-top: 5px;
    padding: 8px;
    background: #f1f2f6;
    border: 1px solid #f1f1f1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .title {
      flex: 1;
      line-height: 35px;
      font-size: 16px;
      margin-left: 8px;
    }
    .ybpay {
      flex: 1;
      font-size: 16px;
      text-align: center;
      margin-left: 5px;
      margin-right: 5px;
      line-height: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .list {
    padding: 10px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    color: #747d8c;
    margin-bottom: 15px;

    .listrow {
      display: flex;
      font-size: 15px;
      flex-direction: row;
      margin-left: 10px;
      margin-right: 10px;
      justify-content: space-between;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #5b8df6aa;

      .red {
        color: #e74c3c;
      }
    }
  }
  .content_title {
    width: 90%;
    margin: 0px auto;
    color: #5b8df6aa;
    text-align: center;
    font-size: 18px;
    letter-spacing: 10px;
    margin-bottom: 5px;
  }
  .last_item {
    width: 10px;
    height: 1px;
    margin-bottom: 70px;
  }
  .detail {
    .red {
      color: #5b8df6aa;
    }
    color: #747d8c;
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: 0px auto;
    border-top: 3px dashed #a4b0be;
    border-bottom: 3px dashed #a4b0be;
    border-left: 15px dashed #a4b0be;
    border-right: 15px dashed #a4b0be;
    margin-bottom: 20px;
    //   box-shadow: inset 3px 3px #a4b0be;

    .listrow {
      font-size: 15px;
      display: flex;
      flex-direction: row;
      margin-left: 10px;
      margin-right: 10px;
      justify-content: space-between;
      height: 35px;
      line-height: 30px;
      border-bottom: 1px dashed #5b8df6aa;
      .price {
        color: #5b8df6;
        // width: 40px;
        flex: 2;
        text-align: center;
      }
      .count {
        align-items: center;
        align-content: center;
        flex: 2;
        text-align: center;
      }
      .itemName {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // width: 140px;
        //规定段落中的文本不进行换行
      }
      .project_c {
        text-align: center;
      }
    }
  }
}
.pay_list_foot {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #aaaaaaaa;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 70px;

  .pay_text {
    margin-left: 20px;
    color: #aaaaaa;
    .money {
      color: #e74c3c;
    }
  }
  .pay_button {
    background-color: #5b8df6;
    margin-right: 20px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
}
.show_tite {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 25px;
}
.show_name {
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
.van-popup {
  height: 78px;
}
.van-popup--top.van-popup--round {
  border-radius: 0 0 10px 10px;
}
.last_list {
  font-size: 15px;
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  margin-right: 10px;
  justify-content: space-between;
  height: 35px;
  line-height: 30px;
  border-top: 1px solid red;
  .price {
    color: #5b8df6;
    // width: 40px;
    flex: 2;
    text-align: center;
  }
  .count {
    align-items: center;
    align-content: center;
    flex: 2;
    text-align: center;
  }
  .itemName {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: 140px;
    //规定段落中的文本不进行换行
  }
  .project_c {
    text-align: center;
  }
}
</style>